import React, { Component } from 'react';


export default class LogoutBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: null
		}
	}

	logOutCalled() {
		localStorage.setItem("selectedFacility", null);
		localStorage.setItem("user", null);
		localStorage.setItem("isLoggedIn", false);
		window.location.assign('/');
		//window.location.reload();
	}

	render() {
		return(
			<div>
				<div>
					<button className="btn btn-grey-full" onClick={this.logOutCalled}>Logout</button>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/commons/LogoutBox.js